import { BetSlipSecureWinSettingResult } from "@api-types/agency/autocashout";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export class AutocashoutApiService {
	static baseUrl(config: ApiRequestContextData | null) {
		return `${WEBPACK_BASE_ADDRESS}${config?.agencyKey}/auto-cashout`;
	}

	static getRequestHeaders(config: ApiRequestContextData | null) {
		const appHeaders = getApplicationRequestHeaders(config);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	}

	static async setSecureWinConfiguration(
		betSlipId: string,
		threshold: number,
		options?: ContextOptions
	): Promise<BetSlipSecureWinSettingResult> {
		const secureWinConfigurationModel = {
			betSlipId,
			threshold,
		};
		const context = getApiRequestContext(options);

		const response: BetSlipSecureWinSettingResult = await httpClient.put(
			`${this.baseUrl(context)}/${betSlipId}/bet-slip-secure-win-setting`,
			JSON.stringify(secureWinConfigurationModel),
			this.getRequestHeaders(context)
		);

		return response;
	}

	static async removeSecureWinConfiguration(
		betSlipId: string,
		options?: ContextOptions
	): Promise<void> {
		const context = getApiRequestContext(options);

		const response = await httpClient.delete(
			`${this.baseUrl(context)}/${betSlipId}/bet-slip-secure-win-setting`,
			this.getRequestHeaders(context)
		);

		return response;
	}
}
